export class UnknownError extends Error {
	errorObject: any;
	status?: number;
	traceId?: string;
	constructor(unknownObject: any) {
		super(unknownObject?.message || 'Unknown error');
		this.errorObject = unknownObject;
		this.status = unknownObject?.status;
		this.traceId = unknownObject?.traceId;
	}
}
